import { ErrorHandler, Injectable, isDevMode, NgZone } from '@angular/core';
import { GenericDialogsService } from '@siza-staff-care/shared/generic-dialogs';

const ShowJsError = false;

@Injectable({
	providedIn: 'root',
})
export class CustomErrorHandler implements ErrorHandler {
	constructor(
		private genericDialogs: GenericDialogsService,
		private ngZone: NgZone,
	) {}

	handleError(error: unknown): void {
		this.ngZone.run(() => {
			if (isDevMode()) {
				console.error(error);

				setTimeout(() => {
					alert(error);
				}, 100);
			} else {
				// TODO: Install Raygun - eventually

				// For now, dump the error to the console.
				console.error(error);

				let additionalMsg = '';
				if (typeof error === 'object' && error?.['message']) {
					if (ShowJsError) {
						additionalMsg = `</br></br><em>${error['message']}</em>`;
					} else {
						additionalMsg = `</br></br><em>Front-end error - see console for details.</em>`;
					}
				}

				const msg = `A data error has occurred. Please contact SMI support for advice and resolution. ${additionalMsg}`;

				this.genericDialogs.message({
					message: msg,
					title: 'Error',
					asHtml: true,
				});
			}
		});
	}

	handleErrorFromGenericErrorHandler(error: unknown, context: string): void {
		console.error(`CONTEXT: ${context}`);
		this.handleError(error);
	}
}
